import { ConfigHelper } from '@devxdiscover/devhub-common';
import axios, { AxiosResponse } from 'axios';

type encryptResponse = AxiosResponse & {
  input: string;
  encrypted?: string;
  decrypted?: string;
};

const AnonymousUser = 'anonymous';
/**
 * Encrypts a string using the backend service.
 * @param text The text to encrypt.
 */
export async function encrypt(text: string): Promise<string> {
  try {
    const response = await axios.post<encryptResponse>(
      ConfigHelper.instance.apiUrl(`/kms/encrypt`).href,
      { input: text },
      { timeout: 1000 },
    );
    if (response.status !== 200) {
      return AnonymousUser;
    }
    return response.data?.encrypted ?? '';
  } catch (err) {
    return AnonymousUser;
  }
}
